import e from "react";
import d from "./index127.mjs";
import t from "./index223.mjs";
import b from "classnames";
const N = ({
  title: c,
  onClose: n,
  Icon: l,
  classes: m,
  variation: r,
  permanent: s,
  linkLabel: i,
  onLinkClick: o
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "banner",
    className: b(
      m,
      r ? t[`banner-${r}`] : null,
      t.banner
    )
  },
  l ? /* @__PURE__ */ e.createElement("div", { "data-testid": "banner-icon", className: t.icon }, /* @__PURE__ */ e.createElement(l, null)) : null,
  /* @__PURE__ */ e.createElement("div", { className: t.body }, /* @__PURE__ */ e.createElement("div", { "data-testid": "banner-title", className: t.title }, c), i ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "banner-link",
      className: t.link,
      onClick: o
    },
    i
  ) : null),
  s ? null : /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "close-icon",
      onClick: () => {
        n && n();
      },
      className: t.icon_close,
      role: "button",
      tabIndex: 0,
      "aria-label": I18n.t("booking_engine.information.close"),
      onKeyDown: (a) => {
        (a.key === "Enter" || a.key === " ") && (a.preventDefault(), n && n());
      }
    },
    /* @__PURE__ */ e.createElement(d, null)
  )
);
export {
  N as Banner
};
